import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  BETWEEN_HOURS,
  MENU_HOURS_EXPIRED,
  CHANGE_LOCATION,
  CART_ITEMS_EXPIRED
} from 'cart/constants/notificationTypes';
import BetweenMenusNotificationContainer from 'base/containers/BetweenMenusNotificationContainer';
import MenuHoursExpiredNotificationContainer from 'base/containers/MenuHoursExpiredNotificationContainer';
import LocationChangedNotificationContainer from 'base/containers/LocationChangedNotificationContainer';
import CartItemsExpiredNotificationContainer from 'base/containers/CartItemsExpiredNotificationContainer';
import { closeNotificationModal } from 'base/actions/notificationModals';
import ModalRoot from 'base/containers/ModalRoot';

class NotificationModalContainer extends React.Component {
  static propTypes = {
    notificationModalType: PropTypes.oneOf([BETWEEN_HOURS, MENU_HOURS_EXPIRED]),
    dispatch: PropTypes.func
  };

  closeModal = () => {
    this.props.dispatch(closeNotificationModal());
  };

  render() {
    const { notificationModalType } = this.props;
    return (
      <ModalRoot>
        {notificationModalType === BETWEEN_HOURS && (
          <BetweenMenusNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === MENU_HOURS_EXPIRED && (
          <MenuHoursExpiredNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CHANGE_LOCATION && (
          <LocationChangedNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CART_ITEMS_EXPIRED && (
          <CartItemsExpiredNotificationContainer closeModal={this.closeModal} />
        )}
      </ModalRoot>
    );
  }
}

const mapStateToprops = state => {
  return {
    notificationModalType: state.notificationModal.notificationType
  };
};

export default connect(mapStateToprops)(NotificationModalContainer);
